export default {
  getVehicleData: state => state.vehicleEdited,
  getVehicleStatuses: state => state.vehicleStatuses,
  getVehicles: state => state.vehicles,
  getFreeVehicles: state => state.freeVehicles,
}
